<template>
    <div class="container">
        <div class="search" style="display: flex">
            <el-form ref="formRef" style="flex: 1" :inline="true" :model="search" class="demo-form-inline">
                <el-form-item>
                    <el-input @keyup.enter="onSearch" v-model.trim="search.uid" placeholder="用户UID"
                        size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input @keyup.enter="onSearch" v-model.trim="search.account" placeholder="用户账号"
                        size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSearch">查询</el-button>
                    <el-button size="small" @click="resetForm">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 列表 -->
        <el-table border :data="list" :empty-text="emptyText" v-loading="loading" size="small">
            <el-table-column label="用户UID" width="180">
                <template v-slot="{ row }">
                    <span style="color: #409eff; cursor: pointer" @click="viewUserDetail(row)">
                        {{ row.uid }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="用户账号" width="200">
                <template v-slot="{ row }">
                    <span v-if="row.accountVisible">{{ row.account }}</span>
                    <el-button v-else type="text" :loading="accountLoading[row.uid + '_' + row.region]"
                        @click="viewUserAccount(row)">
                        <i class="el-icon-view" style="font-size: 18px; color: #409eff"></i>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="用户昵称" prop="nickname" min-width="120"></el-table-column>
            <el-table-column label="区域" prop="region"></el-table-column>
            <el-table-column label="终端">
                <template v-slot="{ row }">
                    <span>{{ appName[row.schema] || row.schema }}</span>
                </template>
            </el-table-column>
            <el-table-column label="国家码" prop="country"></el-table-column>
            <el-table-column label="时区" prop="zone"></el-table-column>
            <el-table-column label="注册时间" width="160">
                <template v-slot="{ row }">
                    <span>{{ formatTimestamp(row.create_time) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
                <template v-slot="{ row }">
                    <el-button type="primary" size="mini" @click="viewUserDetail(row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            v-model:currentPage="search.page" :page-size="search.limit" :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next" :total="total" background
            style="margin-top: 16px; justify-content: flex-end">
        </el-pagination>
    </div>
</template>

<script>
import { ref, reactive, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import queryApi from '../../../axios/queryApi'

dayjs.extend(utc)

export default {
    name: 'QueryUserList',
    setup() {
        const { proxy } = getCurrentInstance()
        const router = useRouter()

        const search = reactive({ uid: '', account: '', page: 1, limit: 10 })
        const list = ref([])
        const total = ref(0)
        const loading = ref(false)
        const emptyText = ref('请输入用户UID或用户账号进行查询')
        const appName = reactive({})
        const accountLoading = reactive({})

        function formatTimestamp(timestamp) {
            if (!timestamp || timestamp === 0) return ''
            return dayjs.unix(timestamp).utc().format('YYYY-MM-DD HH:mm:ss')
        }

        function onSearch() {
            if (!search.uid && !search.account) {
                proxy.$message.warning('请输入用户UID或用户账号中的至少一个')
                return
            }
            loading.value = true
            queryApi.QueryUserList({ ...search }).then(res => {
                if (res.data.code == 200) {
                    const data = res.data.data.data || []
                    list.value = data.map(item => ({ ...item, accountVisible: false }))
                    total.value = res.data.data.page_info.total
                    if (data.length === 0) emptyText.value = '暂无数据'
                } else {
                    proxy.$message.error('获取失败：' + res.data.msg)
                }
                loading.value = false
            }).catch(() => { loading.value = false })
        }

        function resetForm() {
            search.uid = ''
            search.account = ''
            search.page = 1
            search.limit = 10
        }

        function handleCurrentChange(val) {
            search.page = val
            onSearch()
        }

        function handleSizeChange(val) {
            search.limit = val
            search.page = 1
            onSearch()
        }

        function viewUserAccount(row) {
            if (!row.uid || !row.region) { proxy.$message.error('缺少必要参数'); return }
            const key = row.uid + '_' + row.region
            accountLoading[key] = true
            queryApi.QueryUserAccount({ uid: row.uid, region: row.region }).then(res => {
                if (res.data.code == 200 && res.data.data?.account) {
                    const idx = list.value.findIndex(item => item.uid === row.uid)
                    if (idx !== -1) {
                        list.value[idx].account = res.data.data.account
                        list.value[idx].accountVisible = true
                    }
                } else {
                    proxy.$message.error('获取用户账号失败')
                }
                accountLoading[key] = false
            }).catch(() => {
                proxy.$message.error('获取用户账号失败')
                accountLoading[key] = false
            })
        }

        function viewUserDetail(row) {
            if (!row.uid || !row.region) { proxy.$message.error('缺少必要参数'); return }
            router.push({ path: '/iot/query/userdetail/' + row.uid + '&' + row.region })
        }

        function getAppList() {
            queryApi.QueryAppList({ page: 1, limit: 100 }).then(res => {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(item => { appName[item.code] = item.name })
                }
            })
        }

        getAppList()

        return {
            search, list, total, loading, emptyText, appName, accountLoading,
            formatTimestamp, onSearch, resetForm, handleCurrentChange, handleSizeChange,
            viewUserAccount, viewUserDetail
        }
    }
}
</script>
